const Settings = () => (
  <svg viewBox='0 0 24 24'>
    <path d='M7.454 7.454H3.818V3.818h3.636v3.636Z' />
    <path d='M7.454 6.243H5.028V3.816h2.425l.001 2.427Zm0 13.937H3.818v-3.636h3.636v3.636Z' />
    <path d='M7.454 18.968H5.03v-2.425h2.424l.001 2.425ZM20.182 7.454h-3.636V3.818h3.636v3.636Z' />
    <path d='M20.181 6.243h-2.424V3.816h2.424v2.427Zm0 13.937h-3.635v-3.636h3.636v3.636Z' />
    <path d='M20.181 18.969h-2.424v-2.426h2.424v2.426ZM8.363 8.36H5.636V5.634h2.728l-.001 2.727Z' />
    <path d='M8.363 7.454H6.544V5.636h1.819v1.818Z' />
    <path d='M8.363 7.454H6.544V5.636h1.819v1.818Zm3.032-1.818V2h2.424v3.636h-2.425Z' />
    <path d='M10.181 5.637V2h2.425v3.636l-2.425.001Zm.91 12.724v-2.727h7.272v2.729l-7.271-.002Z' />
    <path d='M7.455 18.363v-2.729h7.272v2.729H7.455Zm3.03-10V5.636h6.06v2.728l-6.06-.001Z' />
    <path d='M7.456 8.363V5.634h6.058v2.729H7.456Zm-1.82 2.424h2.727v6.667H5.636v-6.667Z' />
    <path d='M5.636 7.454h2.727v6.667H5.636V7.454ZM8.364 8.97h1.819v1.211H8.364V8.97Z' />
    <path d='M8.364 8.363h1.819v1.211H8.364V8.363Zm5.455.606h1.818v1.21H13.82V8.97Z' />
    <path d='M13.818 8.363h1.819v1.211h-1.819V8.363Zm0 6.061h1.819v1.212h-1.819v-1.212Z' />
    <path d='M13.819 13.817h1.818v1.212H13.82v-1.212Zm-5.455.607h1.819v1.212H8.364v-1.212Z' />
    <path d='M8.364 13.817h1.819v1.212H8.364v-1.212Zm7.272-3.333h2.727v6.06h-2.727v-6.06Z' />
    <path d='M15.636 7.454h2.727v6.06h-2.727v-6.06Zm-3.03 10.909v3.636H10.18v-3.636h2.425Z' />
    <path d='M13.819 18.363V22h-2.425v-3.636l2.425-.001ZM2 11.09h3.636v1.819H2V11.09Zm0-.91h3.636v.91H2v-.91ZM21.09 12h-3.636v-1.82h3.636V12Zm0 .908h-3.636v-.909h3.636v.91Z' />
    <path d='M18.364 11.394H22v2.425h-3.636v-2.425Z' />
    <path d='M18.364 10.181H22v2.425h-3.636V10.18ZM5.637 12.607H2V10.18h3.636l.001 2.425Z' />
    <path d='M5.637 13.819H2v-2.425h3.636l.001 2.425Z' />
  </svg>
)

export { Settings }
